import * as THREE from 'three';

export function setupEnvironment(scene: THREE.Scene): void {
  // Key light: warm directional from upper-right-front
  const keyLight = new THREE.DirectionalLight(0xfff5e6, 2.5);
  keyLight.position.set(3, 4, 5);
  keyLight.castShadow = true;
  keyLight.shadow.mapSize.set(2048, 2048);
  keyLight.shadow.camera.near = 0.1;
  keyLight.shadow.camera.far = 20;
  keyLight.shadow.camera.left = -3;
  keyLight.shadow.camera.right = 3;
  keyLight.shadow.camera.top = 3;
  keyLight.shadow.camera.bottom = -1;
  scene.add(keyLight);

  // Fill light: cool from left
  const fillLight = new THREE.DirectionalLight(0xe6f0ff, 0.8);
  fillLight.position.set(-3, 2, 2);
  scene.add(fillLight);

  // Ambient base
  scene.add(new THREE.AmbientLight(0xffffff, 0.3));

  // Hemisphere: sky/ground tint
  scene.add(new THREE.HemisphereLight(0xddeeff, 0xf5efe6, 0.5));

  // Shadow-catching ground plane
  const groundGeo = new THREE.PlaneGeometry(20, 20);
  const groundMat = new THREE.ShadowMaterial({ opacity: 0.15 });
  const ground = new THREE.Mesh(groundGeo, groundMat);
  ground.rotation.x = -Math.PI / 2;
  ground.position.y = -0.001;
  ground.receiveShadow = true;
  scene.add(ground);
}
